//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMsg } from '../../assets/js/context';
import { EventSourcePolyfill } from "event-source-polyfill";
import global from "../../assets/js/global";
import { Toast } from "vant";
import { chatChat, pageChat } from "@/api/create";
import { getInfo } from "@/api/my";
import { queryPayLog, applePayVerify } from "@/api/buy";
import { insertData, queryBy, updateData } from "../../assets/js/sql";
import { packageChatSpecific, pageCreate, chatV4Params } from "@/api/create";
import html2canvas from "html2canvas";
import axios from "axios";
import QRCode from "qrcode";
import Afooter from "@/components/Afooter";
const crypto = require("crypto");
export default {
  name: "home",
  components: {
    Afooter,
  },
  data: function () {
    return {
      titleIndex: 0,
      userInfo: {},
      scrollHeight: 0,
      showCancellation: false,
      shareFriendModal: false,
      imgHeight: 0,
      top: 0,
      bottom: 0,
      contentH: 0,
      qrcodeImg: "",
      html2Img: "",
      shareImgW: 0,
      shareImgH: 0,
      shareImgUrl: "",
      showShare: false,
      options: [
        { name: "微信", icon: "wechat", type: 0 },
        { name: "朋友圈", icon: "wechat-moments", type: 1 },
        { name: "复制链接", icon: "link", type: 2 },
        { name: "分享海报", icon: "poster", type: 3 },
      ],
      voice: false,
      keyboardUp: false,
      msg: "",
      startRefresh: false,
      quickList: [],
      isIphone: false,
      questionList: [],
      iap: {},
      currentScrollTop: 0, //当前滚动的高度，解决页面跳转回来页面保持
      firstLoad: true,
      autoScroll: false, //是否自动滚动
      needScroll: true, // 是否需要滚动， 当用户触发页面滚动的时候 停止提问滚动
      queueAnswer: '',
      writeDone: true,
      stillThink: false,
      stillAnswer: false,
      allAnswer: '',
      currentAnswerIndex: '',
      currentSavedConversationDetailID: '',
      currentSavedChatID: '',
      currentStopTalk: false
    };
  },
  created () {
    this.getQuick()
    if (global.isApp) {
      this.top = api.safeArea.top;
      this.bottom = api.safeArea.bottom;
      if (api.systemType === "ios") {
        var iap = api.require("iap");
        this.iap = iap;
        let _this = this;
        iap.setTransactionListener(
          {
            autoFinishTransaction: false,
          },
          function (ret, err) {
            console.log("首页 发起交易回调: ", ret.state);
            if (ret) {
              _this.checkTransactionState(ret);
            } else {
              console.log("首页 监听回调: ", JSON.stringify(err));
            }
          }
        );
      } else {
        let agreed = localStorage.getItem("showAgree");
        if (!agreed) {
          this.showCancellation = true;
        }
      }
    } else {
      console.log(navigator.userAgent);
      var userAgent = navigator.userAgent;
      var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
      console.log('Home mounted:', isAndroid, isiOS)
      this.isIphone = isiOS;
    }
  },
  mounted () {
    this.contentH = 46 + this.top + 60 + 60 + this.bottom;
    console.log(this.contentH, document.documentElement.clientHeight);
    if (global.isApp) {
      let _this = this;
      api.addEventListener(
        {
          name: "keyboardshow",
        },
        function (ret, err) {
          _this.keyboardUp = true;
          _this.contentH = 46 + _this.top + 60 + _this.bottom;
          console.log(
            "监听键盘",
            _this.contentH,
            JSON.stringify(ret),
            _this.keyboardUp
          );
          setTimeout(() => {
            var div = document.getElementById("homeCenter");
            if (div) {
              div.scrollTop = div.scrollHeight;
            }
            var div1 = document.getElementById("chatCenter");
            if (div1) {
              div1.scrollTop = div1.scrollHeight;
            }
          }, 100);
        }
      );
      api.addEventListener(
        {
          name: "keyboardhide",
        },
        function (ret, err) {
          _this.keyboardUp = false;
          _this.contentH = 46 + _this.top + 60 + 60 + _this.bottom;
          console.log(
            "监听键盘",
            _this.contentH,
            JSON.stringify(ret),
            _this.keyboardUp
          );
        }
      );
    } else {
      // // document.getElementById('homeCenter').style.height = 'calc(100vh )
      // this.resizeTextarea({
      //   maxHeight: 100,
      //   minHeight: 10
      // }, true)
    }
    this.getList();
    window.addEventListener('scroll', this.handleScroll, true)
  },
  activated () {
    console.log('环境：', process.env.NODE_ENV)
    this.getUser();
    //获取专家的type集合
    this.getExpertTypes()
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    // this.getList()
    var div = document.getElementById("homeCenter");
    if (div && this.questionList.length) {
      this.$nextTick(() => {
        var div = document.getElementById("homeCenter");
        if (!div) return
        div.scrollTop = this.currentScrollTop
      });
    }
    console.log("home s activated:", this.currentScrollTop, div.scrollTop);
  },
  deactivated () {
    var div = document.getElementById("homeCenter");
    if (div) {
      this.currentScrollTop = div.scrollTop
      console.log("home deactivated", this.currentScrollTop);
    }
  },
  destroyed () {
    console.log("destroyed home");
  },
  methods: {
    showStopBtn (index, aIndex) {
      if (this.currentAnswerIndex === index && this.currentChildIndex === aIndex && this.stillAnswer) {
        return true
      } else {
        return false
      }
    },
    showCopyBtn(index, aIndex) {
      if (this.currentAnswerIndex !== index) {
        return true
      } else {
        if (this.currentChildIndex !== aIndex) {
          return true
        } else {
          if (this.stillAnswer) {
            return false
          } else {
            return true
          }
        }
      }
    },
    stopTalk (index, aIndex, child) {
      this.currentStopTalk = true
      this.stillThink = false
      this.stillAnswer = false
      this.allAnswer = child.answer
      let item = this.questionList[index]
      item.child[aIndex] = child
      this.$set(this.questionList[index], "answer", child.answer);
      this.$set(this.questionList[index], "child", item.child);
      if (aIndex > 0) { // 重新回答
        let time = Date.now()
        let obj = {
          conversationDetailId: item.id,
          type: child.type,
          status: 'normal',
          question: child.question,
          answer: child.answer,
          createTime: time,
          updateTime: time
        }
        if (this.currentSavedChatID) {
          obj.id = this.currentSavedChatID
          this.updateChatData(obj)
        } else {
          this.saveChatData(obj)
        }
      } else {
        if (this.currentSavedConversationDetailID) {
        // 更新数据库
          this.updateConversationDetailData()
        } else {
          //存储
          this.saveConversationDetailData()
        }
      }
      
    },
    newChat () {
      this.$router.push({
        path: '/chat?type=new'
      })
    },
    getExpertTypes() {
      pageCreate().then(res => {
        let dataList = res.data
        console.log(dataList.map(item => item.type))
        localStorage.setItem('create', JSON.stringify(dataList))
      })
      packageChatSpecific().then(res => {
        let expertList = res.data
        localStorage.setItem('specific', JSON.stringify(expertList))
      })
    },
    goDownload () {
      console.log('iphone:', this.isIphone)
      // if (this.isIphone) {
      //   location.href = 'https://apps.apple.com/app/%E5%B0%8F%E6%B4%BD%E5%8A%A9%E6%89%8B/id6446100744'
      // } else {
        location.href = 'https://www.pgyer.com/yLzs'
      // }
    },
    toChatList () {
      this.$router.push({
        path: '/mychat'
      })
    },
    checkTransactionState (ret) {
      // 0 //已加入交易队列 SKPaymentTransactionStatePurchasing //商品已添加进列表
      // 1 //交易完成 SKPaymentTransactionStatePurchased
      // 2 //交易失败 SKPaymentTransactionStateFailed
      // 3 //恢复购买 SKPaymentTransactionStateRestored 已购买过商品
      // 4 //交易等待被确认 SKPaymentTransactionStateDeferred 排队
      console.log("交易状态：", ret.state);
      console.log("state: ", ret.state);
      if (ret.state * 1 === 1) {
        console.log(
          "originalTransactionId: ",
          ret.originalTransactionId,
          ret.applicationUsername,
          ret.receipt.substr(0, 20)
        );
        console.log("applicationUsername: ", ret.applicationUsername);
        console.log("receipt: ", ret.receipt.substr(0, 20));
        console.log("productId: ", ret.productId);
        console.log("transactionId: ", ret.transactionId);
      }
      let state = ret.state * 1;
      let _this = this;
      switch (state) {
        case 0: //SKPaymentTransactionStatePurchasing
          console.log("已加入交易队列");
          break;
        case 1: //SKPaymentTransactionStatePurchased
          if (ret.originalTransactionId) {
            // 如果是自动续费的订单，有originalTransactionId
            console.log("续订");
          } else {
            //普通购买，以及第一次购买自动订阅
            console.log("首次订阅");
          }
          api.hideProgress();
          _this.sendReceipt(ret);
          break;
        case 2: //SKPaymentTransactionStateFailed
          api.hideProgress();
          _this.failedTransaction(ret);
          break;
        case 3: //SKPaymentTransactionStateRestored
          api.hideProgress();
          console.log("已购买过的商品");
          _this.sendReceipt(ret);
          break;
        case 4: //SKPaymentTransactionStateDeferred
          console.log("交易等待被确认");
          break;
        default:
          break;
      }
    },
    resizeTextarea (autosize) {
      this.$refs.inputMsg.$el.style.height = "auto";
      let height = this.$refs.inputMsg.$el.scrollHeight;
      if ((0, this.isObject)(autosize)) {
        const { maxHeight, minHeight } = autosize;
        if (maxHeight !== void 0) {
          height = Math.min(height, maxHeight);
        }
        if (minHeight !== void 0) {
          height = Math.max(height, minHeight);
        }
      }
      if (height) {
        this.$refs.inputMsg.$el.style.height = `${height}px`;
      }
    },
    setRootScrollTop (value) {
      this.setScrollTop(window, value);
      this.setScrollTop(document.body, value);
    },
    setScrollTop (el, value) {
      if ("scrollTop" in el) {
        el.scrollTop = value;
      } else {
        el.scrollTo(el.scrollX, value);
      }
    },
    getRootScrollTop () {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    isObject (val) {
      return val !== null && typeof val === "object";
    },
    goBottom () {
      var div = document.getElementById("homeCenter");
      if (!div) return
      div.scrollTop = div.scrollHeight;
      document.documentElement.scrollTop = div.scrollHeight;
      document.getElementById("text-input").scrollTop = 10000
    },
    sendReceipt (ret) {
      if (!localStorage.getItem("token")) {
        return;
      }
      let _this = this;
      let result = ret;
      applePayVerify({
        orderNo: ret.applicationUsername,
        receipt: ret.receipt,
        transactionId: ret.transactionId,
      })
        .then((res) => {
          console.log("Verify:", JSON.stringify(res));
          if (res.data.payStatus * 1 === 1) {
            console.log("支付成功");
            // api.toast({
            //   msg: '支付成功',
            //   duration: 2000,
            //   location: 'center',
            // })
            _this.finishTransaction(result.transactionId);
          } else {
            _this.checkApplyOrder(result);
          }
        })
        .catch((v) => {
          console.log("Verify catch: ", JSON.stringify(v));
          // if (v.code === 500) {
          // }
        });
    },
    failedTransaction (ret) {
      console.log("交易失败", ret.errorCode);
      this.finishTransaction(ret.transactionId);
      api.hideProgress();
      if (ret.errorCode * 1 === 0) {
        console.log("未知错误");
      } else if (ret.errorCode * 1 === 2) {
        // 取消购买
        api.alert({
          msg: "支付取消",
        });
      } else {
        api.alert({
          msg: "支付失败",
        });
      }
    },
    finishTransaction (transactionId) {
      console.log("完成交易");
      this.iap.finishTransaction({
        transactionId: transactionId,
      });
      this.getUser();
      api.hideProgress();
      // closeToast()
    },
    checkApplyOrder (ret) {
      console.log("查询订单状态");
      queryPayLog({
        orderSn: ret.originalTransactionId
          ? ret.originalTransactionId
          : ret.transactionId,
      }).then((res) => {
        if (res.data.payStatus === 3) {
          setTimeout(() => {
            this.checkApplyOrder(ret);
          }, 3000);
        } else if (res.data.payStatus === 1) {
          // api.toast({
          //   msg: '支付成功',
          //   duration: 2000,
          //   location: 'center',
          // })
          this.finishTransaction(ret.transactionId);
        } else {
          api.toast({
            msg: "支付失败",
            duration: 2000,
            location: "center",
          });
          this.finishTransaction(ret.transactionId);
        }
      });
    },

    shareTimeline () {
      axios
        .get("https://ttt.genepre.com/weixin/getWxConfig?url=" + location.href)
        .then((res) => {
          let data = Object.assign(res.data.data, { debug: true });
          wx.config(data);
          wx.ready(() => {
            console.log(211);
            //分享到朋友圈
            wx.onMenuShareTimeline({
              title: "title", // 分享时的标题
              desc: "12312",
              link: "https://ttt.genepre.com", // 分享时的链接
              imgUrl:
                "https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png", // 分享时的图标
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              },
              fail: function (res) {
                console.log("fail" + JSON.stringify(res));
              },
              complete: function (res) {
                //接口调用完成时执行的回调函数，无论成功或失败都会执行。
                console.log("complete" + JSON.stringify(res));
              },
            });
          });
          wx.error((res) => {
            console.log("err", res);
          });
        });
    },
    shareApp () {
      wx.onMenuShareAppMessage({
        title: "111",
        desc: "123123",
        link: location.href,
        imgUrl:
          "https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png",
        type: "",
        dataUrl: "",
        success: function () {
          console.log("分享成功");
        },
        cancel: function () {
          console.log("取消分享");
        },
        fail: function (res) {
          console.log("fail" + JSON.stringify(res));
        },
        complete: function (res) {
          //接口调用完成时执行的回调函数，无论成功或失败都会执行。
          console.log("complete" + JSON.stringify(res));
        },
      });
    },
    getPixelRatio (context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      return (window.devicePixelRatio || 1) / backingStore;
    },
    getDPR () {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    /**
     * 将传入值转为整数
     * @param value
     * @returns {number}
     */
    parseValue: function (value) {
      return parseInt(value, 10);
    },
    drawAndShareImage () {
      // 获取像素比
      var scaleBy = this.getDPR();
      let width = this.shareImgW * scaleBy;
      let height = this.shareImgH * scaleBy;
      let pageH = window.screen.height * scaleBy; // height + footerImgH
      let footerImgW = width;
      let footerImgH = (footerImgW * 558) / 1080;
      let footerImgX = 0;
      let footerImgY = pageH - footerImgH;

      let imgTop = 15 * scaleBy;
      let imgY = imgTop + 5 * scaleBy;
      let imgH = pageH - footerImgH - imgTop * 2;
      let imgW = (imgH * width) / height;
      let imgX = (width - imgW) / 2;

      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = pageH;
      var context = canvas.getContext("2d");
      context.rect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "transparent";
      context.fill();
      var shareBkImg = new Image();
      shareBkImg.src = "../../../static/home/sharebk.png";
      shareBkImg.crossOrigin = "Anonymous";
      let _this = this;
      shareBkImg.onload = function () {
        console.log("img load");
        context.drawImage(shareBkImg, 0, 0, width, pageH);
        // var bkImg = new Image()
        // bkImg.crossOrigin = 'Anonymous'
        // bkImg.onload = function() {
        //   context.drawImage(bkImg, imgX, imgY, imgW, imgH)
        //   console.log('bkImg:', bkImg.width, bkImg.height)
        var domImage = new Image();
        domImage.src = _this.html2Img; //背景图片 你自己本地的图片或者在线图片
        domImage.crossOrigin = "Anonymous";
        domImage.onload = function () {
          context.drawImage(domImage, imgX, imgY, imgW, imgH);
          var footerImg = new Image();
          footerImg.src = "../../../static/home/sharefooter.png"; //你自己本地的图片或者在线图片
          footerImg.crossOrigin = "Anonymous";
          footerImg.onload = function () {
            context.drawImage(
              footerImg,
              footerImgX,
              footerImgY,
              footerImgW,
              footerImgH
            );
            var qrcodeDom = document.getElementById("qrcode");
            let url =
              process.env.BASE_URL +
              '/home' +
              "?inviteCode=" +
              _this.userInfo.inviteCode;
            QRCode.toCanvas(
              qrcodeDom,
              url,
              {
                errorCorrectionLevel: "H",
                type: "image/png",
                quality: 0.3,
                margin: 1,
              },
              function (error, dom) {
                if (error) console.error(error);
                _this.qrcodeImg = dom.toDataURL("image/png");
                _this.$nextTick(() => {
                  let qrImg = new Image();
                  qrImg.src = _this.qrcodeImg;
                  qrImg.onload = () => {
                    context.drawImage(
                      qrImg,
                      width - 15 * scaleBy - footerImgH / 2,
                      pageH - footerImgH / 2 - footerImgH / 3,
                      footerImgH / 2,
                      footerImgH / 2
                    );
                    var base64 = canvas.toDataURL("image/png"); //"image/png" 这里注意一下
                    let img = new Image()
                    _this.shareImgUrl = base64;
                    img.src = _this.shareImgUrl
                    img.onload = () => {
                      _this.imgHeight = document.documentElement.clientWidth * 1.78
                      _this.shareFriendModal = true;
                      Toast.clear();
                    }
                  };
                });
              }
            );
          };
        };
        // }
      };
    },
    goMyChat () {
      this.$router.push({
        path: '/mychat'
      })
    },
    shareUrl () {
      let _this = this;
      const toast = Toast.loading({
        message: "生成中...",
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
      });
      let centerDom = document.getElementById("home");
      let box = window.getComputedStyle(centerDom);
      // dom节点计算后宽高
      var width = _this.parseValue(box.width);
      var height = _this.parseValue(box.height);
      this.shareImgW = width;
      this.shareImgH = height;
      // 获取像素比
      var scaleBy = _this.getDPR();
      // 创建自定义的canvas元素
      var canvas = document.createElement("canvas");

      // 设置canvas元素属性宽高为 DOM 节点宽高 * 像素比
      canvas.width = width * scaleBy;
      canvas.height = height * scaleBy;

      // 设置canvas css 宽高为DOM节点宽高
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";

      // 获取画笔
      var context = canvas.getContext("2d");
      context.fillStyle = "transparent";
      context.fill();

      // 将所有绘制内容放大像素比倍
      context.scale(scaleBy, scaleBy);

      html2canvas(centerDom, {
        backgroundColor: null,
        width: width,
        height: height,
        useCORS: true,
        allowTaint: true
      }).then((canvas) => {
        this.html2Img = canvas.toDataURL("image/png");
        console.log('截图成功', this.html2Img)
        this.drawAndShareImage();
      });
    },
    onSelect (option) {
      switch (option.type) {
        case 0:
          this.shareApp();
          break;
        case 1:
          this.shareTimeline();
          break;
        case 2:
          this.copyUrl();
          break;
      }
    },
    copyUrl () {
      var input = document.createElement("input");
      input.setAttribute("id", "copyInput");
      input.setAttribute("value", location.href);
      document.body.appendChild(input);
      document.getElementById("copyInput").select();
      document.execCommand("copy");
      Toast.success("已复制");
      document.body.removeChild(input);
      this.showShare = false;
    },
    disAgree () {
      if (global.isApp) {
        api.closeWidget({
          id: "A6122368097326",
          silent: true,
        });
      }
    },
    agree () {
      if (global.isApp) {
        localStorage.setItem("showAgree", "1");
        this.showCancellation = false;
        this.$bus.emit("showAgree", 1);
        this.getUser();
      }
    },
    doAndroidLogin () {
      let token = localStorage.getItem("token");
      console.log("token:", token);
      let deviceId = localStorage.getItem("deviceId");
      if (!token) {
        if (!localStorage.getItem("deviceId")) {
          deviceId = api.deviceId;
          localStorage.setItem("deviceId", deviceId);
        }
        androidLogin({
          udid: deviceId,
        }).then((res) => {
          localStorage.setItem("token", res.data.token);
        });
      }
    },
    getUser () {
      if (global.isApp && !localStorage.getItem("deviceId")) {
        return;
      }
      if (!global.isApp && !localStorage.getItem("uuid")) {
        return;
      }
      if (!localStorage.getItem("token")) {
        return;
      }
      if (global.isApp && !localStorage.getItem("showAgree")) {
        return;
      }
      console.log("home: info");
      getInfo().then((res) => {
        this.userInfo = res.data;
        if (res && res.data && res.data.unionId) {
          localStorage.setItem("unionId", res.data.unionId);
        } else {
          localStorage.removeItem("wxToken");
          localStorage.removeItem("unionId");
        }
      });
    },
    getQuick () {
      pageChat().then((res) => {
        console.log('pageChat: ', res)
        this.quickList = []
        if (res.data.length > 3) {
          this.quickList.push(res.data[0])
          this.quickList.push(res.data[1])
          this.quickList.push(res.data[2])
        } else {
          this.quickList = res.data
        }
      })
    },
    goAgreement () {
      this.$router.push({
        path: "/userAgreement",
      });
    },
    goPrivacy () {
      this.$router.push({
        path: "/privacy",
      });
    },
    async getList () {
      console.log('查询数据开始：', Date.now())
      let res = await queryBy('conversation_detail', 'type', 'homeChat')
      this.questionList = []
      res.data.forEach(async (item, index) => {
        let child = await queryBy('chat', 'conversationDetailId', item.id * 1)
        item.child = child.data
        this.questionList.push(item)
        if (index === res.data.length - 1) {
          this.$nextTick(() => {
            this.scrollToBottom()
          });
        }
      });
      console.log('查询数据结束：', Date.now())
    },
    voiceChange () {
      this.voice = !this.voice;
    },
    copy (value) {
      if (this.$global.isApp) {
        var clipBoard = api.require("clipBoard");
        clipBoard.set(
          {
            value: value,
          },
          function (ret, err) {
            console.log("复制", ret, err);
            if (ret.status) {
              Toast({
                message: "复制成功",
                duration: 1000,
              });
            } else {
              Toast({
                message: "复制失败",
                duration: 1000,
              });
            }
          }
        );
      } else {
        var input = document.createElement("input");
        input.setAttribute("id", "copyInput");
        input.setAttribute("value", value);
        document.body.appendChild(input);
        document.getElementById("copyInput").select();
        document.execCommand("copy");
        Toast.success("复制成功");
        document.body.removeChild(input);
      }
    },
    sendMsg () {
      console.log(this.msg);
      if (this.isNull(this.msg)) {
        Toast({
          message: "信息不能为空",
          duration: 2000,
        });
        return;
      }
      this.answer(this.msg.replace(/(^s*)|(s*$)/g, ""));
    },
    isNull (str) {
      if (str == "") return true;
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      return re.test(str);
    },
    scrollToBottom () {
      if (!this.needScroll) {
        return
      }
      var div = document.getElementById("homeCenter");
      if (!div) return
      div.scrollTop = div.scrollHeight;
      document.documentElement.scrollTop = div.scrollHeight;
      this.needScroll = true
    },
    sign (timestampStr, uuid) {
      // console.log('签名：', timestampStr, uuid)
      let secret = "l8c2scudgvf3aavrkuohep4r6a16nj7s"
      let stringToSign = timestampStr + uuid;
      let mac = crypto.createHmac("sha256", secret);
      mac.update(stringToSign);
      let signData = mac.digest();
      let signStr = Buffer.from(signData).toString("base64");
      let stringToSignStr = Buffer.from(stringToSign).toString("base64");
      return signStr + stringToSignStr;
    },
    //时间戳转换成日期时间
    js_date_time(unixtime) {
      var dateTime = new Date(parseInt(unixtime))
      var year = dateTime.getFullYear();
      var month = dateTime.getMonth() + 1;
      var day = dateTime.getDate();
      var hour = dateTime.getHours();
      var minute = dateTime.getMinutes();
      var second = dateTime.getSeconds();
      // var now = new Date();
      // var now_new = Date.parse(now.toDateString()); //typescript转换写法
      // var milliseconds = now_new - dateTime;
      var timeSpanStr = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      return timeSpanStr;
    },
    async sseAnswer(index, paramsId, retryChatItem) {
      this.currentStopTalk = false
      let sse;
      let uid = window.localStorage.getItem("uid");
      if (uid == null || uid == '' || uid == 'null') {
        uid = this.uuid();
      }
      // 设置本地存储
      // window.localStorage.setItem("uid", uid);
      let _this = this;
      let uuid_str = this.uuid();
      let headers = {}
      if (global.isApp) {
        // 1，把timestamp+uuid当做签名字符串，使用HmacSHA256算法计算签名，然后进行Base64 encode。
        // 2,把timestamp+uuid和第一步得到的签名值拼接到前面去
        // 3,把结果放到请求头里，Authorization : Bearer2 rBrGIfY1nL0u7KFpQ+VOXSj6q+ye3b/3SPxK03YtaNA=MTY3ODA4NTUxNDY0MEZDNDA4RjhCLTk1OTgtNDhCNi1BNzQwLUI5MDM3QURDWFhYRQ==
        let deviceId = localStorage.getItem('deviceId')
        let Bearer = "";
        if (api.systemType === "ios") {
          Bearer = "Bearer1 ";
          headers['gptsystem'] = 'ios'
        } else {
          headers['gptsystem'] = 'android'
          // 安卓目前取不到唯一的deviceId
          if (!deviceId) {
            deviceId = api.deviceId;
            localStorage.setItem("deviceId", deviceId);
          }
          Bearer = "Bearer2 ";
        }
        let wxToken = localStorage.getItem("wxToken");
        let appleToken = localStorage.getItem("appleToken");
        let token = localStorage.getItem("token");
        if (deviceId) {
          const timestamp = new Date().getTime();
          let signStr = this.sign(timestamp.toString(), deviceId);
          headers["Authorization"] = Bearer + signStr;
        }
        // let channelCode = localStorage.getItem('channelCode')
        // if (channelCode && channelCode !== 'none' && channelCode !== '') {
        //   headers['Terminal'] = channelCode
        // }
        if (wxToken) {
          headers["Token"] = Bearer + wxToken;
        } else if (appleToken) {
          headers["Token"] = Bearer + appleToken;
        } else if (token) {
          headers["Token"] = Bearer + token;
        }
      } else {
        let uuid = localStorage.getItem('uuid')
        let token = localStorage.getItem('token')
        // if (!uuid) {
        //   uuid = getUuid()
        // }
        const timestamp = new Date().getTime()
        let signStr = this.sign(timestamp.toString(), uuid)
        headers['Authorization'] = 'Bearer3 ' + signStr
        if (token) {
          headers['Token'] = 'Bearer3 ' + token
        }
      }
      headers['uid'] = this.uuid()
      // process.env.API_HOST
      // https://gpt.gaoshan.co/apitest
      const eventSource = new EventSourcePolyfill(process.env.API_HOST +  '/chat/v4?paramsId=' + paramsId, {
          headers: headers
      });
      eventSource.onopen = (event) => {
        console.log("onopen", event, event.readyState, event.target);
        sse = event.target;
      };
      let child = []
      if (retryChatItem) { // 如果是重新回答，取出当前问答的所有答案
        child = retryChatItem.child
        child.push({
          conversationDetailId: retryChatItem.id,
          type: 'homeChat',
          status: 'normal',
          answer: ''
        })
      } else {
        child.push({
          type: 'homeChat',
          status: 'normal',
          answer: ''
        })
      }
      let answer = ''
      this.allAnswer = ''
      eventSource.onmessage = async (event) => {
        if (this.currentStopTalk) {
          if (sse) {
            sse.close();
          }
          return;
        }
        if (event.data == "[DONE]") {
          console.log('结束')
          this.allAnswer = answer
          this.questionList[index].answer = answer
          if (retryChatItem) {
            let time = Date.now()
            let obj1 = {
              conversationDetailId: retryChatItem.id,
              type: retryChatItem.type,
              status: 'normal',
              question: retryChatItem.question,
              answer: this.questionList[index].answer,
              createTime: time,
              updateTime: time
            }
            this.saveChatData(obj1)
          // this.retryScroll(index)
          } else {
            this.saveConversationDetailData()
          }
          
          if (sse) {
            sse.close();
          }
          return;
        }
        let json_data = JSON.parse(event.data)
        if (json_data.content == null || json_data.content == 'null') {
          return;
        }
        answer += json_data.content
        this.queueAnswer += json_data.content
        console.log('index:', index)
        console.log('answer: ', json_data.content, Date.now())
        this.queue(index, child)
        this.$nextTick(() => {
          this.scrollToBottom()
        }, 100);
      };
      eventSource.onerror = (event) => {
        this.stillAnswer = false
        this.stillThink = false
        if (this.questionList.length) {
          let child = []
          let answer = "网络异常!"
          child.push({
            type: 'homeChat',
            status: '1000',
            answer: answer
          })
          this.$set(this.questionList[index], "answer", answer);
          this.$set(this.questionList[index], "child", child);
        }
        console.log("onerror 服务异常请重试并联系开发者！", event);
        if (event.readyState === EventSource.CLOSED) {
          console.log('connection is closed');
        } else {
          console.log("Error occured", event);
        }
        event.target.close();
      };
      eventSource.addEventListener("customEventName", (event) => {
        console.log("Message id is " + event.lastEventId);
      });
    },
    async queue (index, child) {
      setTimeout(async ()=> {
        if (this.writeDone) {
          let msg = this.queueAnswer
          this.queueAnswer = ''
          console.log(msg)
          if (!msg) {
            return
          }
          if (this.currentStopTalk) {
            return
          }
          this.writeDone = false
          this.stillThink = false
          this.stillAnswer = true
          let res = await this.typeMessage(index, child, msg, 50, false);
          this.writeDone = res
        } else {
          if (!this.queueAnswer) {
            return
          }
          this.queue(index, child)
        }
      }, 500)
    },
    // 调用 typeMessage 函数来逐字输出消息
    // typeMessage("Hello, world! This is a test message.", 50);
    async typeMessage (index, child, message, delay, doSave) {
       return new Promise((resolve,reject) => {
          let i = 0;
          const intervalId = setInterval(() => {
            // console.log(message.charAt(i))
            let msg = message.charAt(i)
            if (this.currentStopTalk) {
             clearInterval(intervalId);
             resolve(true)
            }
            child[child.length - 1].answer += msg
            this.$set(this.questionList[index], "answer", child[child.length - 1].answer);
            this.$set(this.questionList[index], "child", child);

            // this.questionList[index].child = child;
            this.$nextTick(() => {
              this.scrollToBottom()
            }, 100);
            // outputDiv.innerHTML += message.charAt(i);
            i++;
            if (i > message.length) {
              if (this.allAnswer === child[child.length - 1].answer) {
                console.log('输出完成')
                this.stillAnswer = false
              }
              if (doSave) {
                this.allAnswer = this.questionList[index].answer
                this.stillAnswer = false
                this.saveConversationDetailData()
              }
              clearInterval(intervalId);
              resolve(true)
            }
          }, delay);
      });
    },
    uuid () {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    async quickAnswer (item) {
      if (this.stillThink) {
        Toast('小洽正在思考您的问题，请稍候')
        return
      }
      if (this.stillAnswer) {
        Toast('小洽正在回答您的问题，请稍候')
        return
      }
      this.stillThink = true
      this.needScroll = true
      let index = this.questionList.length;
      this.currentAnswerIndex = index
      this.currentChildIndex = 0
      this.questionList.push({
        question: item.question,
        answer: "",
        child: [
          {
            type: '',
            answer: ''
          }
        ]
      });
      setTimeout(() => {
        this.scrollToBottom(true)
      }, 100);
      setTimeout(async () => {
        let child = []
        child.push({
          type: 'homeChat',
          status: 'normal',
          answer: ''
        })
        this.stillThink = false
        this.stillAnswer = true
        this.questionList[index].answer = item.answer
        console.log('开始')
        let res = await this.typeMessage(index, child, item.answer, 50, true);
        console.log('结束', res)
        // this.questionList[index].answer = item.answer;
        // this.questionList[index].child = child;
        this.$nextTick(() => {
          this.scrollToBottom()
        }, 1100);
      }, 1000);
      // '到目前为止，没有硬性证据表明外星人真实存在。尽管我们已经在太阳系以外的行星上发现了一些可居住的区域，但还没有被证明有生命存在。然而，对于宇宙的深度和广度，以及我们已经发现的生命形式的多样性来看，有些科学家和研究人员认为外星人可能存在是有可能的，甚至可能是普遍存在的。但是，这仍然是一个科学问题，并且需要更多研究来确定所有外星生命的存在及其性质。'
    },
    handleScroll () {
      let count = 1
      count++
      if (count > 10) {
        this.needScroll = false
      }
      // let scrollTop = document.getElementById('homeCenter').scrollTop;
      //   console.log('【滚动距离】', scrollTop);
      if (!document.getElementById('homeCenter')) {
        return
      }
      let ch = document.getElementById('homeCenter').clientHeight;
      // console.log('【可视区域】', ch);
      //   let sh = document.getElementById('homeCenter').scrollHeight;
      //   console.log('【滚动条高度】', sh);
    },
     retryChat (item, index) {
      this.needScroll = true
      this.stillThink = true
      let list = this.questionList.filter((item, i) => i < index)
      this.currentAnswerIndex = index
      this.currentChildIndex = item.child.length
      let messages = getMsg(list, item.question)
      console.log('上下文：', messages)
      let currentItem = JSON.parse(JSON.stringify(item))
      // 追加一条空chat数据 用于显示正在思考中...
      item.child.push({
        type: 'homeChat',
        answer: ''
      });
      this.currentSavedConversationDetailID = ''
      this.currentSavedChatID = ''
      this.$set(this.questionList[index], "child", item.child);
      setTimeout(() => {
        this.scrollToBottom()
      }, 100);
      // this.retryScroll(index)
      // if (item) {
      //   return
      // }
      chatV4Params({
        messages: messages,
      }).then((res) => {
        // console.log(res);
        if (res.code === 405) {
          this.stillThink = false
          this.stillAnswer = false
          let child = currentItem.child
          child.push({
            type: 'homeChat',
            status: 'subscribe',
            answer: res.message
          })
          this.$set(this.questionList[index], "child", child);
          // setTimeout(() => {
            // this.$router.push({
            //   path: "/subscribe?type=nobalance",
            //   query: {
            //     from: 'home'
            //   }
            // });
          // }, 10);
          return;
        }
        if (res.code === 200) {
          this.sseAnswer(index, res.data.paramsId, currentItem)
          // let child = currentItem.child
          // child.push({
          //   conversationDetailId: item.id,
          //   type: 'homeChat',
          //   status: 'normal',
          //   answer: data
          // })
          // this.$set(this.questionList[index], "child", child);
          // console.log('ssss: ', this.questionList[index])
          // "conversationDetailId",
          // "type", //类型
          // "title", //
          // "question", //问题
          // "answer", //回答
          // "createTime", //创建时间
          // "updateTime", //更新时间
          // let time = Date.now()
          // let obj1 = {
          //   conversationDetailId: item.id,
          //   type: item.type,
          //   status: 'normal',
          //   question: item.question,
          //   answer: data,
          //   createTime: time,
          //   updateTime: time
          // }
          // this.saveChatData(obj1)
          // this.retryScroll(index)
        }
      })
        .catch((v) => {
          // console.log("err", v);
          this.stillThink = false
          this.stillAnswer = false
          if (v.code === 401 && !localStorage.getItem("wxToken")) {
            console.log("游客过期");
            if (this.questionList.length) {
              let child = currentItem.child
              child.push({
                conversationDetailId: item.id,
                type: 'homeChat',
                status: 'device401',
                answer: '小洽刚刚开小差了，请您再问一次'
              })
              this.$set(this.questionList[index], "child", child);
            }
          } else {
            if (this.questionList.length) {
              let answer = v.message || "网络异常!"
              let childIndex = item.child.length
              item.child[childIndex - 1] = {
                type: 'homeChat',
                status: v.code || '1000',
                answer: answer
              }
              this.$set(this.questionList[index], "child", item.child);
            }
          }
        });
    },
    // retryScroll (index) {
    //   setTimeout(() => {
    //     var div = document.getElementById("homeCenter");
    //     if (!div) return
    //     var messageBox = document.getElementById("message_" + index)
    //     let ch = document.getElementById('homeCenter').clientHeight;
    //     let scrollTop = messageBox.scrollHeight + messageBox.offsetTop - ch;
    //     console.log('【可视区域】', ch);
    //     if (div.scrollTop > scrollTop) {
    //       return
    //     }
    //     if (!this.needScroll) {
    //       return
    //     }
    //     div.scrollTop = scrollTop
    //     console.log('滚动到：', div.scrollTop)
    //     document.documentElement.scrollTop = scrollTop
    //     this.needScroll = true
    //   }, 100);
    // },
     updateConversationDetailData () {
      let time = Date.now()
      let obj = {
        id: this.currentSavedConversationDetailID,
        type: 'homeChat',
        question: this.questionList[this.currentAnswerIndex].question,
        answer: this.questionList[this.currentAnswerIndex].answer,
        createTime: time,
        updateTime: time
      }
      updateData("conversation_detail", obj).then(res => {
        // chat 数据
        let obj1 = {
          conversationDetailId: res.target.result,
          type: obj.type,
          status: 'normal',
          question: obj.question,
          answer: obj.answer,
          createTime: obj.createTime,
          updateTime: obj.updateTime
        }
        if (this.currentSavedChatID) {
          // 更新chat
          obj1.id = this.currentSavedChatID
          this.updateChatData(obj1)
        } else {
          // 存储chat
          this.saveChatData(obj1)
        }
      })
    },
    saveConversationDetailData () {
      // conversation_detail 数据 首页会话未创建关联conversation 此处可不存 conversationId
      let time = Date.now()
      let obj = {
        type: 'homeChat',
        question: this.questionList[this.currentAnswerIndex].question,
        answer: this.questionList[this.currentAnswerIndex].answer,
        createTime: time,
        updateTime: time
      }
      insertData('conversation_detail', obj).then((res) => {
        this.currentSavedConversationDetailID = res.target.result
        // chat 数据
        let obj1 = {
          conversationDetailId: res.target.result,
          type: obj.type,
          status: 'normal',
          question: obj.question,
          answer: obj.answer,
          createTime: obj.createTime,
          updateTime: obj.updateTime
        }
        this.saveChatData(obj1)
      });
    },
    updateChatData (obj) {
       updateData("chat", obj).then(res => {
       })
    },
    saveChatData (obj) {
      insertData('chat', obj).then((res) => {
        this.currentSavedChatID = res.target.result
      });
    },
    answer (question) {
      if (this.stillThink) {
        Toast('小洽正在思考您的问题，请稍候')
        return
      }
      if (this.stillAnswer) {
        Toast('小洽正在回答您的问题，请稍候')
        return
      }
      this.stillThink = true
      this.needScroll = true
      this.msg = "";  //输入框文字
      // this.resetContentH()
      let index = this.questionList.length;
      this.currentAnswerIndex = index
      this.currentChildIndex = 0
      let messages = getMsg(this.questionList, question)
      console.log('上下文：', messages)
      // 追加一条空chat数据 用于显示正在思考中...
      this.questionList.push({
        question: question,
        answer: "",
        child: [
          {
            type: '',
            answer: ''
          }
        ]
      });
      this.currentSavedConversationDetailID = ''
      this.currentSavedChatID = ''
      setTimeout(() => {
        this.scrollToBottom()
      }, 100);

      // chatV3({
      chatV4Params({
        messages: messages,
      })
      .then((res) => {
        // console.log(res);
        if (res.code === 405) {
          this.stillAnswer = false
          this.stillThink = false
          let child = []
          child.push({
            type: 'homeChat',
            status: 'subscribe',
            answer: res.message
          })
          this.$set(this.questionList[index], "answer", res.message);
          this.$set(this.questionList[index], "child", child);
          setTimeout(() => {
          this.$router.push({
            path: "/subscribe?type=nobalance",
            query: {
              from: 'home'
            }
          });
        }, 1000);
          return;
        }
        if (res.code === 200) {
          // console.log('chatV3:', res.data)
          this.sseAnswer(index, res.data.paramsId)
        }
      })
      .catch((v) => {
        this.stillAnswer = false
        this.stillThink = false
        // console.log("err", v);
        if (v.code === 401 && !localStorage.getItem("wxToken")) {
          console.log("游客过期");
          if (this.questionList.length) {
            let child = []
            child.push({
              type: 'homeChat',
              status: 'device401',
              answer: '小洽刚刚开小差了，请您再问一次'
            })
            this.$set(this.questionList[index], "answer", "小洽刚刚开小差了，请您再问一次");
            this.$set(this.questionList[index], "child", child);
          }
        } else {
          if (this.questionList.length) {
            let child = []
            let answer = v.message || "网络异常!"
            child.push({
              type: 'homeChat',
              status: v.code || '1000',
              answer: answer
            })
            this.$set(this.questionList[index], "answer", answer);
            this.$set(this.questionList[index], "child", child);
          }
        }
        setTimeout(() => {
          this.scrollToBottom()
        }, 100);
      });
    },
    goSubscribe () {
      this.$router.push({
        path: "/subscribe",
      });
    },
    goSetting () {
      this.$router.push({
        path: "/setting",
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Home/home.vue